import React from 'react';

import CashAppProvider from '../../../checkout/components/CashAppProvider/CashAppProvider';
import { Component as PaymentMethodProvider } from '../../../checkout/components/PaymentMethodProvider';
import PsourceProvider from '../../../checkout/components/PsourceProvider/PsourceProvider';

import { updateDebugFlags } from './actions';
import checkoutModule from './checkoutModule';

export default function checkoutExtension() {
  return {
    id: 'checkout',
    server: process.browser
      ? undefined
      : {
          init() {
            require('./config');
          },
          configure(server) {
            const {
              getRedirectAuthSendIframe,
              getRedirectAuthReturnIframe,
            } = require('./utils/adyen');

            server.get('/checkout/authorize3d', (req, res) => {
              res.send(getRedirectAuthSendIframe());
            });
            server.post('/checkout/authorize3d', (req, res) => {
              res.send(getRedirectAuthReturnIframe(req.body));
            });
          },
        },
    app: {
      render(props, children) {
        return (
          <PaymentMethodProvider>
            <PsourceProvider>
              <CashAppProvider>{children}</CashAppProvider>
            </PsourceProvider>
          </PaymentMethodProvider>
        );
      },
    },
    page(options) {
      return {
        async getInitialProps(ctx) {
          if (ctx?.req?.query?.test_order === '1') {
            await ctx.store.dispatch(updateDebugFlags({ testOrder: true }));
          }
        },
      };
    },
    redux: {
      modules: [checkoutModule],
    },
  };
}
